import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import LogoBlack from 'src/assets/images/gigsafe-logo-black.svg'

interface Props {
  title: string
  description?: ReactNode
  children?: ReactNode
  dataTestId?: string
}

/**
 * The one full-page card every pre-app state renders into — sign in, the access check, a refusal,
 * a misconfigured build. They are all the same screen with different words, so sharing the frame
 * keeps a refusal from looking like a different product than the sign-in it follows.
 */
const AuthScreenComponent = ({ title, description, children, dataTestId }: Props) => {
  return (
    <div
      data-testid={dataTestId}
      css={tw`flex min-h-screen w-full items-center justify-center bg-shades-50 px-6`}
    >
      <div
        css={tw`flex w-full max-w-[420px] flex-col items-center gap-4 rounded-xl bg-shades-0 px-8 py-10 text-center shadow-lg`}
      >
        <img src={LogoBlack} alt="GigSafe" css={tw`h-[25px]`} />
        <Typography variant="h4" css={tw`font-bold`}>
          {title}
        </Typography>
        {description ? (
          <Typography variant="body2" css={tw`text-shades-500`}>
            {description}
          </Typography>
        ) : null}
        {children}
      </div>
    </div>
  )
}

export const AuthScreen = memo(AuthScreenComponent)
